import { HasDependencies, hashString } from '../../api/types';
import { ApiUser } from '../../api/user/types';
import { Domains } from '../../constants';
import { Mixpanel } from '../../context/mixpanel';
import { getMomentDate } from '../../utils-date';

const getCurrentTime = () => {
  return getMomentDate().format('MMMM Do YYYY, h:mm:ss');
};

export class BaseTracker implements HasDependencies {
  constructor(readonly mixpanel: Mixpanel) {}

  public getDeps = () => [hashString([...this.mixpanel.getDeps()])];

  /**
   * Include with current location for tracking events
   */
  public track = (event: string, data = {}) => {
    this.mixpanel.actions.track(event, {
      ...data,
      timeStamp: getCurrentTime(),
      location: window.location.href,
    });
  };
}

export class BaseAuthedTracker implements HasDependencies {
  constructor(
    readonly baseTracker: BaseTracker,
    readonly currentUser: ApiUser
  ) {}

  public getDeps = () => [
    hashString([...this.baseTracker.getDeps(), this.currentUser.email]),
  ];

  /**
   * Include with current location and current user for tracking events
   */
  public track = (event: string, domain: Domains, data = {}) => {
    this.baseTracker.mixpanel.actions.people().set({ domain });

    // Avoid spamming with techuser events
    if (this.currentUser?.email !== 'techuser@panalyt.com') {
      this.baseTracker.track(event, {
        ...data,
        $email: this.currentUser?.email,
        domain,
      });
    }
  };
}
